var _defs, _rect, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-4{fill:none;stroke:#00ac71;stroke-width:1.4px;}.cls-2{stroke-linecap:round;stroke-miterlimit:10;}.cls-3{fill:#00ac71;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.9126,
    y1: 26,
    x2: 22.0875,
    y2: 26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.50745,10.65967l-4.53894-.00391V5.39941A1.4039,1.4039,0,0,0,16.5686,4H13.43152a1.40389,1.40389,0,0,0-1.3999,1.39941v5.25l-4.53687-.0039a.89075.89075,0,0,0-.6864,1.46L14.32227,21.415a.89088.89088,0,0,0,1.37072-.00049l7.49915-9.29443A.89136.89136,0,0,0,22.50745,10.65967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.50745,10.65967l-4.53894-.00391V5.39941A1.4039,1.4039,0,0,0,16.5686,4H13.43152a1.40389,1.40389,0,0,0-1.3999,1.39941v5.25l-4.53687-.0039a.89075.89075,0,0,0-.6864,1.46L14.32227,21.415a.89088.89088,0,0,0,1.37072-.00049l7.49915-9.29443A.89136.89136,0,0,0,22.50745,10.65967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.116b1b47a220e35760db8f76dde69021.svg";
export { ForwardRef as ReactComponent };